import createUseNotifier from './createUseNotifier';

const createNotificationContainer = notifier => {
  const useNotifier = createUseNotifier(notifier);

  const NotificationContainer = ({
    render
  }) => {
    const value = useNotifier();
    const rendered = render(value);
    return rendered;
  };

  if (process.env.NODE_ENV !== 'production') {
    NotificationContainer.displayName = 'NotificationContainer';
  }

  return [NotificationContainer, useNotifier];
};

export default createNotificationContainer;